<template>
  <div>
    <v-toolbar flat class="mt-2 mb-2">
      <!-- Left Section -->
      <div class="d-flex align-center">
        <v-toolbar-title class="mr-4">Cancel Printed Books</v-toolbar-title>
        <v-checkbox v-model="scannerActive" label="Scan QR code " dense class="mt-4"></v-checkbox>
        <v-btn color="error" :disabled="selectedBooks.length === 0" @click="cancelSelectedBooks"
          v-if="selectedBooks.length !== 0" class="ml-6">
          Cancel Selected
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <!-- Right Section -->
      <div class="d-flex align-center">
        <v-select :items="activeSchedules" v-model="selectedSchedule" return-object item-text="title" label="Session"
          id="scheduleBtn" dense class="mr-4 mt-4" style="max-width: 200px;"
          :rules="[(v) => !!v || 'Session is required']" required :clearable="false" @change="onScheduleChange" />
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" id="searchBtn" single-line hide-details
          dense style="max-width: 200px;" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          @keydown="preventNonNumericalInput" @keydown.enter.prevent="handleSearchEnter"></v-text-field>
      </div>
    </v-toolbar>
    <!-- Scanner Row -->
    <v-row v-if="scannerActive">
      <v-col cols="12" class="pt-0 pb-0 d-flex justify-center">
        <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded" />
      </v-col>
    </v-row>
    <v-data-table v-model="selectedBooks" :headers="headers" :items="getBooksForSchedule" sort-by="dateCreated"
      :search="search" :custom-filter="customFilter" show-select item-value="id" class="elevation-1" dense>
      <template v-slot:[`item.dateCreated`]="{ item }">
        <span>{{ new Date(item.dateCreated).toLocaleString() }}</span>
      </template>
      <template v-slot:[`item.schedule.time`]="{ item }">
        <span v-if="item.schedule && item.schedule.time">
          {{ formatTime(item.schedule.time, item.schedule.date) }}
        </span>
        <span v-else>N/A</span>
      </template>
      <template v-slot:[`item.panels`]="{ item }">
        <div v-if="item.panels && item.panels.length">
          <span v-for="panel in item.panels" :key="panel.id">
            {{ panel.panelId }}
          </span>
        </div>
        <span v-else>N/A</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { StreamBarcodeReader } from "vue-barcode-reader";
import { EventBus } from "@/main";
export default {
  components: { StreamBarcodeReader },
  name: "BooksWithScanner",
  computed: {
    ...mapGetters([
      "getScheduleList",
      "getSelectedBookSchedule",
      "getBooksForSchedule",
    ]),
    gameList() {
      return this.selectedSchedule
        ? this.selectedSchedule.selectedTemplates
        : [];
    },
    activeSchedules() {
      return this.getScheduleList.filter(schedule => schedule.active);
    },
  },
  data() {
    return {
      search: "",
      selectedSchedule: null,
      scannerActive: false,
      selectedBooks: [],
      headers: [
        { text: "", value: "data-table-select", width: "30px" },
        { text: "Book ID", value: "id" },

        { text: "Session Name", value: "schedule.title" },
        { text: "Session Date", value: "schedule.date" },
        { text: "Session Time", value: "schedule.time" },
        { text: "Game Title", value: "title" },
        { text: "Pages", value: "pages" },
        // { text: "Player", value: "player.displayName" },
        { text: "Panel IDs", value: "panels" },
        { text: "Date Created", value: "dateCreated" },
      ],
      videoElement: null,
      lastScannedCode: null,
      scanCooldown: false,
    };
  },
  created() {
    this.fetchSchedules();
    EventBus.$on("BARCODE_SCANNED", (data) => {
      this.onDecode(data);
    });
  },
  mounted() {
    this.setSelectedSchedule(null);
    this.$nextTick(() => {
      this.videoElement = this.$el.querySelector("video");
    });
    this.$watch(
      () => this.getScheduleList,
      (newSchedules) => {
        if (newSchedules && newSchedules.length > 0 && !this.selectedSchedule) {
          this.selectedSchedule = newSchedules[0];
        }
      },
      { immediate: true }
    );
  },
  unmounted() {
    this.stopCamera();
  },
  beforeDestroy() {
    this.stopCamera();
    EventBus.$off("BARCODE_SCANNED");
  },
  methods: {
    ...mapActions([
      "fetchSchedules",
      "setSelectedSchedule",
      "fetchBooksForSchedule",
      "cancelPrintedBooks",
    ]),
    formatTime(time, date) {
      console.log("formatTime called with: " + JSON.stringify(time) + ", date: " + date);
      if (!time || !date) return 'N/A';

      try {
        let hours, minutes;

        if (Array.isArray(time) || (typeof time === 'object' && time.length !== undefined)) {
          hours = parseInt(time[0], 10);
          minutes = parseInt(time[1] || 0, 10);
        } else if (typeof time === 'string' && time.includes(',')) {
          [hours, minutes] = time.split(',').map(t => parseInt(t.trim(), 10));
        } else {
          return 'N/A';
        }

        if (isNaN(hours) || isNaN(minutes)) return 'N/A';

        // Parse date string
        const [year, month, day] = date.split('-').map(Number);

        // Create UTC Date object
        const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));

        // Convert to local time
        const localHours = utcDate.getHours();
        const displayHours = localHours % 12 || 12;
        const period = localHours >= 12 ? 'PM' : 'AM';
        const paddedMinutes = String(utcDate.getMinutes()).padStart(2, '0');

        console.log("Formatted time:", `${displayHours}:${paddedMinutes} ${period}`);
        return `${displayHours}:${paddedMinutes} ${period}`;
      } catch (e) {
        console.error("Error formatting time:", e);
        return 'N/A';
      }
    },
    preventNonNumericalInput(e) {
      if (
        [46, 8, 9, 27, 13, 110].includes(e.keyCode) ||
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        return;
      }
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    },
    handleSearchEnter() {
      this.checkNoResults();
      return false;
    },
    customFilter(value, search, item) {
      search = search.toString().toLowerCase();
      const matchesId = item.id
        .toString()
        .toLowerCase()
        .includes(search);
      const matchesTitle = item.title
        .toString()
        .toLowerCase()
        .includes(search);
      const matchesPages = item.pages
        .toString()
        .toLowerCase()
        .includes(search);
      const matchesPlayer =
        item.player && item.player.displayName
          ? item.player.displayName
            .toString()
            .toLowerCase()
            .includes(search)
          : false;
      const matchesDate = item.dateCreated
        ? new Date(item.dateCreated)
          .toLocaleString()
          .toLowerCase()
          .includes(search)
        : false;
      let matchesPanels = false;
      if (item.panels && item.panels.length) {
        matchesPanels = item.panels.some((panel) =>
          panel.panelId
            .toString()
            .toLowerCase()
            .includes(search)
        );
      }
      return (
        matchesId ||
        matchesTitle ||
        matchesPages ||
        matchesPlayer ||
        matchesDate ||
        matchesPanels
      );
    },
    stopCamera() {
      if (this.videoElement && this.videoElement.srcObject) {
        const stream = this.videoElement.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
        this.videoElement.srcObject = null;
      }
    },
    async onDecode(result) {
      if (!result || result.trim() === "") return;
      if (this.scanCooldown || this.lastScannedCode === result) {
        return;
      }

      this.scanCooldown = true;
      this.lastScannedCode = result;

      console.log("Scanned QR Code:", result);
      await this.cancelPrintedBooks({ bookId: [result] });

      if (this.selectedSchedule?.id) {
        await this.fetchBooksForSchedule(this.selectedSchedule.id);
      }
      setTimeout(() => {
        this.scanCooldown = false;
      }, 2000);
    },
    async cancelSelectedBooks() {
      const bookIds = this.selectedBooks.map((book) => book.id).filter(Boolean);
      if (bookIds.length === 0) return;
      await this.cancelPrintedBooks({ bookId: bookIds });
      this.selectedBooks = [];
      if (this.selectedSchedule?.id) {
        this.fetchBooksForSchedule(this.selectedSchedule.id);
      }
    },
    onLoaded() {
      console.log("Scanner ready.");
    },
    checkNoResults() {
      const filteredItems = this.getBooksForSchedule.filter((item) =>
        this.customFilter(null, this.search, item)
      );
      if (this.search && filteredItems.length === 0) {
        this.$snackbar({
          message: "No result found",
          mode: "error",
        });
      }
    },
  },
  watch: {
    scannerActive(newValue) {
      if (!newValue) {
        this.stopCamera();
      } else {
        this.$nextTick(() => {
          this.videoElement = this.$el.querySelector("video");
        });
      }
    },
    selectedSchedule(schedule) {
      if (schedule?.id) {
        this.fetchBooksForSchedule(schedule.id);
      }
    },
    search(newSearch) {
      if (newSearch) {
        this.$nextTick(() => {
          this.checkNoResults();
        });
      }
    },
  },
};
</script>
<style scoped>
.logo {
  max-height: 25px;
}

.square {
  width: 1.25vw;
  height: 1.25vw;
  min-width: 10px;
  min-height: 10px;
  border: rgb(73, 73, 73);
  border-style: solid;
  border-radius: 0.5px;
}

.fluid-container {
  display: flex;
}
</style>
